import React, { Component } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, FormGroup, Label, Input, Row, Col, Alert, Spinner } from "reactstrap";
import moment from "moment";
import axios from "axios";
import classes from '../EditPlaceholderModal/EditPlaceholderModal.module.scss'
import Form from "../../../general/Form/Form";

const config = {
  headers: {
    "Content-Type": "application/json"
  },
  withCredentials: true
};

const initialState = {
  waypointGroupName: null,
  waypointGroupAddresses: null,
  loadedPlaceholderWaypointGroups: false,
  toastHeader: "",
  toastBody: "",
  isToastOpen: false,
  loading: false
};

class EditPlaceholderModal extends Component {
  state = initialState;

  onFormSubmitHandler = async (e) => {
    e.preventDefault();
    let data = {
      name: this.state.waypointGroupName,
      address: this.state.waypointGroupAddresses ? this.state.waypointGroupAddresses.replace(/\r?\n|\r|\t/g, "").split(";") : []
    };
    this.setState({
      loading: true
    })
    if (this.props.edit) {
      try {
        let res = await axios.put(`${process.env.REACT_APP_API_HOST}/waypoint_group/${this.props.id}`, data, config);
        if (res.status === 200 && res.data.updated_waypoint && res.data.updated_waypoint[0].waypoint_group_id) {
          // alert("Updated waypoint group");
          // window.location.reload();
          this.setState({
            toastHeader: 'Success',
            toastBody: 'Updated waypoint group!',
            isToastOpen: true,
            loading: false
          })
          this.toggle(null, true)
          setTimeout(() => {
            this.setState({
              isToastOpen: false
            })
          }, 3000);
          await this.props.loadPage();
        } else if (res.status !== 200) {
          this.setState({
            toastHeader: 'Failure',
            toastBody: 'Problem updating waypoint group!',
            isToastOpen: true,
            loading: false
          })
          setTimeout(() => {
            this.setState({
              isToastOpen: false
            })
          }, 5000);
        }
      } catch (err) {
        console.log(err);
      }
    } else {
      try {
        let res = await axios.post(`${process.env.REACT_APP_API_HOST}/waypoint_group`, data, config);
        if (res.status === 200 && res.data.new_waypoint && res.data.new_waypoint[0].waypoint_group_id) {
          // alert("Added waypoint group");
          // window.location.reload();
          this.setState({
            toastHeader: 'Success',
            toastBody: 'Added waypoint group!',
            isToastOpen: true,
            loading: false
          })
          this.toggle(null, true)
          setTimeout(() => {
            this.setState({
              isToastOpen: false
            })
          }, 3000);
          await this.props.loadPage();
        } else if (res.status !== 200) {
          this.setState({
            toastHeader: 'Failure',
            toastBody: 'Problem adding waypoint group!',
            isToastOpen: true,
            loading: false
          })
          setTimeout(() => {
            this.setState({
              isToastOpen: false
            })
          }, 5000);
        }
      } catch (err) {
        console.log(err);
      }
    }
  };

  componentDidUpdate = async () => {
    if (this.props.id && this.props.edit && !this.state.loadedPlaceholderWaypointGroups) {
      try {
        // get waypoint group info
        let res = await axios.get(`${process.env.REACT_APP_API_HOST}/waypoint_group/${this.props.id}`, {
          withCredentials: true
        });
        if (res.status === 200 && res.data.waypoint && res.data.waypoint[0].waypoint_group_id) {
          let waypoint = res.data.waypoint[0];
          this.setState({
            loadedPlaceholderWaypointGroups: true,
            waypointGroupName: waypoint.name,
            waypointGroupAddresses: waypoint.addresses.join(";\n")
          });
        }
      } catch (err) {
        console.log(err);
      }
    }
  };

  waypointGroupNameChangeHandler = (e) => {
    this.setState({
      waypointGroupName: e.target.value
    });
  };

  waypointGroupAddressesChangeHandler = (e) => {
    this.setState({
      waypointGroupAddresses: e.target.value
    });
  };

  toggle = (id, fetchData) => {
    this.setState(initialState);
    this.props.toggleModal(id, fetchData);
  };

  render() {
    const formStyle = {
      boxShadow: "none"
    };
    return (
      <>
        {this.state.toastHeader === 'Success' && this.state.isToastOpen && 
          <Alert className={classes.alertMsg}>
            {this.state.toastBody}
          </Alert>
        }
        {this.state.toastHeader === 'Failure' && this.state.isToastOpen && 
          <Alert className={classes.alertMsg} color="danger">
            {this.state.toastBody}
          </Alert>
        }
        <Modal isOpen={this.props.show} toggle={() => this.toggle(null, false)} size="lg">
          <ModalHeader toggle={() => this.toggle(null, false)}>{this.props.edit ? "Edit" : "Create"} Waypoint Group</ModalHeader>
          <ModalBody>
            <Form sectionStyle={formStyle} onSubmit={this.onFormSubmitHandler}>
              <Row form className="mb-3">
                <Col>
                  <FormGroup className="mb-2">
                    <Label>Waypoint Group Name</Label>
                    <Input
                      type="text"
                      value={this.state.waypointGroupName ? this.state.waypointGroupName : ""}
                      onChange={this.waypointGroupNameChangeHandler}
                      placeholder="Enter group name..."
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col>
                  <FormGroup>
                    <Label>Waypoint Zipcodes (Separated By Semicolons)</Label>
                    <Input
                      type="textarea"
                      onChange={this.waypointGroupAddressesChangeHandler}
                      value={this.state.waypointGroupAddresses ? this.state.waypointGroupAddresses : ""}
                      placeholder="Enter an address..."
                      style={{ height: "200px" }}
                    />
                  </FormGroup>
                </Col>
              </Row>
            </Form>
          </ModalBody>
          <ModalFooter>
            {/* {deleteButton} */}
            <Button color="primary" onClick={this.onFormSubmitHandler}>
              {this.state.loading ? 
                <Spinner animation="border" variant="light" size="sm" />
                :
                <span>{this.props.edit ? "Save" : "Add"}</span> 
              }
            </Button>
            <Button color="secondary" onClick={() => this.toggle(null, false)}>
              Cancel
            </Button>
          </ModalFooter>
        </Modal>
      </>
    );
  }
}

export default EditPlaceholderModal;
